const deliveryStates = {
  notAvailable: 'Not available yet',
  processing: 'Processing',
  inTransit: 'In Transit',
  outForDelivery: 'Out for Delivery',
  delivered: 'Delivered',
  failure: 'Failure',
  returned: 'Returned',
  damaged: 'Damaged',
  deliveryIssue: 'Delivery issue',
  incompleteOrder: 'Incomplete order',
  wrongItem: 'Wrong item',
}


export default deliveryStates
